// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgChat: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M12 20.18c6.627 0 12-4.151 12-9.272s-5.373-9.273-12-9.273S0 5.787 0 10.908c0 3.298 2.228 6.193 5.584 7.837l-.004 3.012a.6.6 0 0 0 .867.54l4.164-2.058a.605.605 0 0 0 .153-.107A15.7 15.7 0 0 0 12 20.18" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgChat);
export default Memo;
